import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=f604fbe4&scoped=true"
import script from "./list-item.vue?vue&type=script&lang=js"
export * from "./list-item.vue?vue&type=script&lang=js"
import style0 from "./list-item.vue?vue&type=style&index=0&id=f604fbe4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f604fbe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f604fbe4')) {
      api.createRecord('f604fbe4', component.options)
    } else {
      api.reload('f604fbe4', component.options)
    }
    module.hot.accept("./list-item.vue?vue&type=template&id=f604fbe4&scoped=true", function () {
      api.rerender('f604fbe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/search-suggestions-list/list-item.vue"
export default component.exports